export const WEBSITE_EDITOR_TRANSLATIONS: Record<string, { en: string; es: string }> = {
  'websiteEditor.label_e_g_services': { en: 'Label (e.g., Services)', es: 'Etiqueta (ej.: Servicios)' },
  'websiteEditor.anchor_to_section': { en: 'Anchor (to section)', es: 'Ancla (a sección)' },
  'websiteEditor.external_url': { en: 'External URL', es: 'URL externa' },
  'websiteEditor.hero': { en: 'Hero', es: 'Hero' },
  'websiteEditor.workSection': { en: 'Work', es: 'Trabajo' },
  'websiteEditor.services': { en: 'Services', es: 'Servicios' },
  'websiteEditor.contact': { en: 'Contact', es: 'Contacto' },
  'websiteEditor.https_example_com': { en: 'https://example.com', es: 'https://ejemplo.com' },
  'websiteEditor.sticky_header': { en: 'Sticky header', es: 'Header fijo' },
  'websiteEditor.show_cta_button': { en: 'Show CTA button', es: 'Mostrar botón CTA' },
  'websiteEditor.cta_text': { en: 'CTA Text', es: 'Texto CTA' },
  'websiteEditor.footer': { en: 'Footer', es: 'Footer' },
  'websiteEditor.footer_text': { en: 'Footer Text', es: 'Texto del footer' },
  'websiteEditor.social_links_json_array': { en: 'Social Links (JSON array)', es: 'Enlaces sociales (array JSON)' },
  'websiteEditor.main_title': { en: 'Main title *', es: 'Título principal *' },
  'websiteEditor.field_description': { en: 'Description', es: 'Descripción' },
  'websiteEditor.tagline': { en: 'Tagline', es: 'Tagline' },
  'websiteEditor.cta_button_text': { en: 'CTA button text', es: 'Texto del botón CTA' },
  'websiteEditor.primary_cta_url': { en: 'Primary CTA URL', es: 'URL CTA principal' },
  'websiteEditor.secondary_cta_url': { en: 'Secondary CTA URL', es: 'URL CTA secundaria' },
  'websiteEditor.vertical_for_copy_presets': { en: 'Vertical for copy presets', es: 'Vertical para presets de copy' },
  'websiteEditor.general': { en: 'General', es: 'General' },
  'websiteEditor.b2b_services': { en: 'B2B Services', es: 'Servicios B2B' },
  'websiteEditor.ecommerce': { en: 'Ecommerce', es: 'Ecommerce' },
  'websiteEditor.field_title_required': { en: 'Title *', es: 'Título *' },
  'websiteEditor.featured_services': { en: 'Featured services *', es: 'Servicios destacados *' },
  'websiteEditor.service_name': { en: 'Service name', es: 'Nombre del servicio' },
  'websiteEditor.service_description_optional': { en: 'Service description (optional)', es: 'Descripción del servicio (opcional)' },
  'websiteEditor.title_2': { en: 'Title', es: 'Título' },
  'websiteEditor.description_2': { en: 'Description', es: 'Descripción' },
  'websiteEditor.outcomes': { en: 'Outcomes', es: 'Resultados' },
  'websiteEditor.title_3': { en: 'Title', es: 'Título' },
  'websiteEditor.value_e_g_32': { en: 'Value (e.g. +32%)', es: 'Valor (ej.: +32%)' },
  'websiteEditor.description_3': { en: 'Description', es: 'Descripción' },
  'websiteEditor.title_4': { en: 'Title', es: 'Título' },
  'websiteEditor.description_4': { en: 'Description', es: 'Descripción' },
  'websiteEditor.steps': { en: 'Steps', es: 'Pasos' },
  'websiteEditor.title_5': { en: 'Title', es: 'Título' },
  'websiteEditor.description_5': { en: 'Description', es: 'Descripción' },
  'websiteEditor.title_6': { en: 'Title', es: 'Título' },
  'websiteEditor.faq_items': { en: 'FAQ Items', es: 'Items FAQ' },
  'websiteEditor.question': { en: 'Question', es: 'Pregunta' },
  'websiteEditor.answer': { en: 'Answer', es: 'Respuesta' },
  'websiteEditor.title_7': { en: 'Title', es: 'Título' },
  'websiteEditor.site_configuration': { en: 'Site Configuration', es: 'Configuración del sitio' },
  'websiteEditor.domain_base_url': { en: 'Domain / Base URL', es: 'Dominio / URL base' },
  'websiteEditor.https_example_com_2': { en: 'https://example.com', es: 'https://ejemplo.com' },
  'websiteEditor.favicon': { en: 'Favicon', es: 'Favicon' },
  'websiteEditor.seo_meta_tags': { en: 'SEO Meta Tags', es: 'Etiquetas meta SEO' },
  'websiteEditor.meta_title': { en: 'Meta Title', es: 'Meta título' },
  'websiteEditor.website_title_for_search_engines': { en: 'Website title for search engines', es: 'Título del sitio para buscadores' },
  'websiteEditor.meta_description': { en: 'Meta Description', es: 'Meta descripción' },
  'websiteEditor.brief_description_for_search_engines': { en: 'Brief description for search engines', es: 'Descripción breve para buscadores' },
  'websiteEditor.keywords_comma_separated': { en: 'Keywords (comma-separated)', es: 'Palabras clave (separadas por coma)' },
  'websiteEditor.web_design_development_branding': { en: 'web design, development, branding', es: 'diseño web, desarrollo, branding' },
  'websiteEditor.google_analytics_id_g_xxxxxxxxxx': { en: 'Google Analytics ID (G-XXXXXXXXXX)', es: 'ID de Google Analytics (G-XXXXXXXXXX)' },
  'websiteEditor.canonical_url': { en: 'Canonical URL', es: 'URL canónica' },
  'websiteEditor.https_example_com_3': { en: 'https://example.com', es: 'https://ejemplo.com' },
  'websiteEditor.allow_search_engines_to_index': { en: 'Allow search engines to index', es: 'Permitir indexación en buscadores' },
  'websiteEditor.colors': { en: 'Colors', es: 'Colores' },
  'websiteEditor.primary_color': { en: 'Primary Color', es: 'Color primario' },
  'websiteEditor.secondary_color': { en: 'Secondary Color', es: 'Color secundario' },
  'websiteEditor.background_color': { en: 'Background Color', es: 'Color de fondo' },
  'websiteEditor.text_color': { en: 'Text Color', es: 'Color de texto' },
  'websiteEditor.typography': { en: 'Typography', es: 'Tipografia' },
  'websiteEditor.font_family': { en: 'Font Family', es: 'Familia tipografica' },
  'websiteEditor.heading_1_h1': { en: 'Heading 1 (H1)', es: 'Encabezado 1 (H1)' },
  'websiteEditor.font_size_px': { en: 'Font Size (px)', es: 'Tamano de fuente (px)' },
  'websiteEditor.font_weight': { en: 'Font Weight', es: 'Peso de fuente' },
  'websiteEditor.normal': { en: 'Normal', es: 'Normal' },
  'websiteEditor.medium': { en: 'Medium', es: 'Medio' },
  'websiteEditor.semi_bold': { en: 'Semi Bold', es: 'Semi negrita' },
  'websiteEditor.bold': { en: 'Bold', es: 'Negrita' },
  'websiteEditor.extra_bold': { en: 'Extra Bold', es: 'Extra negrita' },
  'websiteEditor.heading_2_h2': { en: 'Heading 2 (H2)', es: 'Encabezado 2 (H2)' },
  'websiteEditor.font_size_px_2': { en: 'Font Size (px)', es: 'Tamano de fuente (px)' },
  'websiteEditor.font_weight_2': { en: 'Font Weight', es: 'Peso de fuente' },
  'websiteEditor.normal_2': { en: 'Normal', es: 'Normal' },
  'websiteEditor.medium_2': { en: 'Medium', es: 'Medio' },
  'websiteEditor.semi_bold_2': { en: 'Semi Bold', es: 'Semi negrita' },
  'websiteEditor.bold_2': { en: 'Bold', es: 'Negrita' },
  'websiteEditor.extra_bold_2': { en: 'Extra Bold', es: 'Extra negrita' },
  'websiteEditor.heading_3_h3': { en: 'Heading 3 (H3)', es: 'Encabezado 3 (H3)' },
  'websiteEditor.font_size_px_3': { en: 'Font Size (px)', es: 'Tamano de fuente (px)' },
  'websiteEditor.font_weight_3': { en: 'Font Weight', es: 'Peso de fuente' },
  'websiteEditor.normal_3': { en: 'Normal', es: 'Normal' },
  'websiteEditor.medium_3': { en: 'Medium', es: 'Medio' },
  'websiteEditor.semi_bold_3': { en: 'Semi Bold', es: 'Semi negrita' },
  'websiteEditor.bold_3': { en: 'Bold', es: 'Negrita' },
  'websiteEditor.extra_bold_3': { en: 'Extra Bold', es: 'Extra negrita' },
  'websiteEditor.body_text': { en: 'Body Text', es: 'Texto base' },
  'websiteEditor.font_size_px_4': { en: 'Font Size (px)', es: 'Tamano de fuente (px)' },
  'websiteEditor.line_height': { en: 'Line Height', es: 'Interlineado' },
  'websiteEditor.bookACallUrl': { en: 'Book a Call URL', es: 'URL de Agendar llamada' },
  'websiteEditor.serifHighlight': { en: 'Serif highlight', es: 'Acento serif' },
  'websiteEditor.emailUrl': { en: 'Email URL', es: 'URL de email' },
  'websiteEditor.whatsappUrl': { en: 'WhatsApp URL', es: 'URL de WhatsApp' },
};
